import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azapata@ibl.mx
 *
 * Bordered card with an icon + title header and an optional right-aligned header
 * action. Reuses the same header styling as the shared SectionSelected component
 * (icon + 16px bold title + bottom divider) without its scroll/height machinery,
 * so it can frame both the work shift builder columns and their inner subcards.
 *
 * @param {Object} props
 * @param {string} props.title - Title translation key.
 * @param {JSX.Element} props.icon - Header icon.
 * @param {JSX.Element} [props.headerEnd] - Optional right-aligned header content (e.g. an action button).
 * @param {string} [props.className] - Extra classes for the outer card.
 * @param {string} [props.borderClass] - Outer card border class (swap to error red to flag a required-empty card).
 * @param {string} [props.bodyClassName] - Extra classes for the body wrapper.
 * @param {React.ReactNode} props.children - Card body.
 */
const TitledCard = ({ title, icon, headerEnd = null, className = "", borderClass = "border-full-shades-300", bodyClassName = "", children }) => {
    const { t } = useTranslation();

    return (
        <div className={`w-100 h-100 card-border-8px ${borderClass} d-flex flex-column ${className}`}>
            <div className='d-flex align-items-center p-16px'>
                <div>{icon}</div>
                <p className='fs-16px ibl-font-w-600 font-color-general-950 mr-2 mb-0'>{t(title)}</p>
                {headerEnd && <div className='ml-auto'>{headerEnd}</div>}
            </div>

            <div className='border-bottom-shades-300' />

            <div className={`p-16px flex-grow-1 ${bodyClassName}`}>
                {children}
            </div>
        </div>
    );
};

export default TitledCard;
